import axios from 'axios';

// "Not found" must mean the server actually said 404 — never a network blip.
export const isNotFound = (error) => error?.response?.status === 404;

// Private recipes are deliberately distinct from missing recipes. The API
// returns this structured 403 both to signed-out visitors and to viewers who
// are signed in as somebody other than the owner.
export const isRecipePrivate = (error) =>
  error?.response?.status === 403 &&
  error?.response?.data?.detail?.code === 'recipe_private';

// GET with automatic retries for transient failures (network errors, 5xx).
// 4xx responses are real answers from the server and are never retried.
export async function getWithRetry(url, config, { retries = 2, delayMs = 500 } = {}) {
  let lastError;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await axios.get(url, config);
    } catch (error) {
      lastError = error;
      const status = error?.response?.status;
      if (status && status >= 400 && status < 500) throw error;
      if (attempt < retries) {
        await new Promise((resolve) => setTimeout(resolve, delayMs * (attempt + 1)));
      }
    }
  }
  throw lastError;
}
